import { useEffect, useState } from 'react';

/*
 * Recursos de PWA do eloOficina: instalação na tela inicial,
 * situação da conexão e armazenamento persistente das fotos.
 */
let eventoInstalacao = null;
const ouvintes = new Set();
const avisar = () => ouvintes.forEach((fn) => fn());

// O evento pode disparar antes do React montar a tela: captura já na importação
// (somente em /oficina, para não interferir na instalação do eloAdmin).
if (/^\/oficina(\/|$)/i.test(window.location.pathname)) {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    eventoInstalacao = e;
    avisar();
  });
  window.addEventListener('appinstalled', () => {
    eventoInstalacao = null;
    avisar();
  });
}

export const estaInstalado = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const ehIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent)
  || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

export function useInstalacao() {
  const [, setVersao] = useState(0);

  useEffect(() => {
    const atualizar = () => setVersao((v) => v + 1);
    ouvintes.add(atualizar);
    return () => ouvintes.delete(atualizar);
  }, []);

  const instalar = async () => {
    if (!eventoInstalacao) return false;
    eventoInstalacao.prompt();
    const { outcome } = await eventoInstalacao.userChoice;
    eventoInstalacao = null;
    avisar();
    return outcome === 'accepted';
  };

  const instalado = estaInstalado();
  return {
    instalado,
    podeInstalar: !instalado && Boolean(eventoInstalacao),
    instrucaoIos: !instalado && ehIos(),
    instalar,
  };
}

export function useOnline() {
  const [online, setOnline] = useState(window.navigator.onLine !== false);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

/** Pede ao navegador para não apagar as fotos guardadas quando faltar espaço. */
export const solicitarArmazenamentoPersistente = () => {
  if (navigator.storage && navigator.storage.persist) {
    navigator.storage.persisted()
      .then((persistido) => (persistido ? true : navigator.storage.persist()))
      .catch(() => {});
  }
};

/** Em desenvolvimento troca o manifest (em produção o postbuild já gera o HTML certo). */
export const aplicarManifestOficina = () => {
  const link = document.querySelector('link[rel="manifest"]');
  if (link && !/manifest-oficina\.json$/.test(link.getAttribute('href') || '')) {
    link.setAttribute('href', `${process.env.PUBLIC_URL}/manifest-oficina.json`);
  }
  const cor = document.querySelector('meta[name="theme-color"]');
  if (cor) cor.setAttribute('content', '#c91d2e');
};
